// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_az-b";
export var colorBlue = "_az-8";
export var colorDot = "_az-0";
export var colorDotLarge = "_az-2";
export var colorDotSmall = "_az-1";
export var colorGreen = "_az-7";
export var colorGrey = "_az-3";
export var colorOrange = "_az-5";
export var colorPink = "_az-a";
export var colorPurple = "_az-9";
export var colorRed = "_az-4";
export var colorYellow = "_az-6";